import {SponsorTypeEnum} from 'modules/coupons/types';
import useCreatePermissionGroup from 'modules/permission-groups/hooks/use-create-permission-group';
import {PermissionGroupProps} from 'modules/permission-groups/types';
import {
  cityPermissions,
  companyPermissions,
  franchisePermissions,
} from 'modules/permission-groups/util/permissions-select';
import React from 'react';

import Creation from 'shared/layout/creation';
import useFormInputs from 'shared/migration-components/form/util';

const CreatePermissionGroup: React.FC = () => {
  const {getInput, getSelect, getSection} =
    useFormInputs<PermissionGroupProps>();
  const sectionInputs = useFormInputs();

  return (
    <Creation
      titleBar={{
        title: 'Novo grupo de permissões',
      }}
      inputs={[
        getInput({name: 'name'}),
        getSelect({
          name: 'type',
          data: [
            {label: 'Empresa', value: SponsorTypeEnum.COMPANY},
            {label: 'Cidade', value: SponsorTypeEnum.CITY},
            {label: 'Franquia', value: SponsorTypeEnum.FRANCHISE},
          ],
        }),
        getSection({
          label: 'Permissões',
          inputs: (data) => {
            const permissionSelect =
              data.type === SponsorTypeEnum.COMPANY
                ? companyPermissions
                : data.type === SponsorTypeEnum.CITY
                ? cityPermissions
                : franchisePermissions;

            return Object.keys(permissionSelect).map((module) =>
              sectionInputs.getMultiSelect({
                name: `permissions.${module}`,
                label: permissionSelect[module].name,
                data: permissionSelect[module].permissions,
              }),
            );
          },
          hidden: (data) => !data.type,
        }),
      ]}
      translationKey="PermissionGroupProps"
      onSubmit={useCreatePermissionGroup}
    />
  );
};

export default CreatePermissionGroup;
